import { useState, useEffect } from 'react';

const useCountdown = (deadline) => {
    const [timeLeft, setTimeLeft] = useState({
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
    });

    const leading0 = (num) => num < 10 ? '0' + num : num.toString();

    useEffect(() => {
        const calculateTimeLeft = () => {
            const time = Date.parse(deadline) - Date.parse(new Date());
            if (time < 0) {
                setTimeLeft({
                    days: '00',
                    hours: '00',
                    minutes: '00',
                    seconds: '00',
                });
            } else {
                setTimeLeft({
                    days: leading0(Math.floor(time / (1000 * 60 * 60 * 24))),
                    hours: leading0(Math.floor((time / (1000 * 60 * 60)) % 24)),
                    minutes: leading0(Math.floor((time / 1000 / 60) % 60)),
                    seconds: leading0(Math.floor((time / 1000) % 60)),
                });
            }
        };

        const intervalId = setInterval(calculateTimeLeft, 1000);

        calculateTimeLeft();

        return () => clearInterval(intervalId);
    }, [deadline]);

    return timeLeft;
};

export default useCountdown;